import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-th';
import Vue from 'vue';
import {template as Template} from 'lodash';
import tippy from 'tippy.js';
import moment from 'moment';

$(function(){
if($('#js-period-calendar').length){
  const periods = $('#js-period-calendar').data('periods');

  window.wowPeriodCalendar = new Vue({
    el: '#js-period-calendar',
    data: {
      periods: periods,
      events: {},
      modalTemplate: '\
        <div class="wow-tour-detail-c__calendar-period-modal js-elm-modal">\
          <div class="wow-tour-detail-c__calendar-period-head"><b>ช่วงเวลาเดินทาง</b></div>\
          <ul class="wow-tour-detail-c__calendar-period-list">\
          <% $.each(periods, function(key, item) { %>\
            <li class="wow-tour-detail-c__calendar-period-item">\
              <div class="wow-tour-detail-c__calendar-period-date"><%= item.period_start %> - <%= item.period_end %></div><div class="wow-tour-detail-c__calendar-period-price"><%= (item.price_adults_double).toLocaleString() %></div> \
            </li>\
          <% }); %>\
          </ul>\
        </div>',
      periodsByMonth: {},
    },
    created: function () {
      var parsePeriods = {};
      
      this.periods.forEach((period) => {
        var startDay = new Date(period.period_start_value);
        var endDay = new Date(period.period_end_value);
        for (var d = startDay; d <= endDay; d.setDate(d.getDate() + 1)) {
          if(!parsePeriods[d.toLocaleDateString()]) parsePeriods[d.toLocaleDateString()] = [];
          parsePeriods[d.toLocaleDateString()].push({
            period_end: period.period_end,
            period_end_value: period.period_end_value,
            period_start: period.period_start,
            period_start_value: period.period_start_value,
            price_adults_double: period.price_adults_double,
            discount_display: period.discount_display,
            price_before_discount: period.price_before_discount,
          });
          //append periodsByMonth
          if( !this.periodsByMonth[startDay.getMonth()+1] ){
            this.periodsByMonth[startDay.getMonth()+1] = {
              count: 1,
              // period_start: startDay,
              period_start: moment(startDay).format('MMMM'),
            }
          }else{
            this.periodsByMonth[startDay.getMonth()+1].count += 1
          }
          // console.log(test)
          // console.log(startDay.getMonth())
        }
      });
      
      this.periods = parsePeriods;
      
    },
    methods: {
      createPopper: function (year = null, month = null) {
        const self = this;
        setTimeout(() => {
          $('.ui-datepicker-calendar .has-period', this.$el).each(function() {
            if(year && month){
              var textDate = `${year}-${month}-${$(this).children().text()}`;
            }else{
              const now = new Date()
              var textDate = `${now.getFullYear()}-${now.getMonth()+1}-${$(this).children().text()}`;
            }
            const date = new Date(textDate);
            const compiled = Template(self.modalTemplate);
            const html = compiled({ 'periods': self.periods[date.toLocaleDateString()] });

            const peroid = self.periods[date.toLocaleDateString()][0];
            let isDiscount = peroid.discount_display ? true : false;
            let priceHtml = `
              <div class="price ${isDiscount ? 'discount' : null}">
                ${peroid.price_adults_double}
              </div>
            `;
            if (isDiscount) {
              priceHtml += `<div class="price-before-discount">
                ${peroid.price_before_discount}
              </div>`;
            }
            $(this).append( priceHtml );

            tippy($(this).children()[0], 
              {
                html: $(html)[0],
                placement: 'bottom',
                // trigger: 'click',
                arrow: true,
                theme: 'wow-tour-detail-c__popper',
              }
            );
          });
        }, 0);
      },
      hendleClickMonth(period_start) {
        const currentDate = $( this.$el ).datepicker( "getDate" );
        if (period_start.getMonth() != currentDate.getMonth()){
          $(this.$el).datepicker( "setDate", period_start );
        }
      }
    },
    mounted: function () {

      $(this.$el).datepicker({
        beforeShowDay: (d) => {
          if(this.periods[d.toLocaleDateString()]){
            return [false, 'has-period'];
          }else{
            return [false, ''];
          }
        },
        yearSuffix: `<span class="ui-datepicker-year custom-datepicker-year">${((new Date()).getFullYear()+543)}</span>`,
        onChangeMonthYear: (year, month, inst) => {
          inst.settings.yearSuffix = `<span class="custom-datepicker-year">${(year + 543)}</span>`;
          this.createPopper(year, month);
        }
      });
      this.createPopper();
      
    },
  });

}

});
